<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="p-field col-12 md:col-6">
        <div class="size_cent form-margin">
          <p-checkbox
            [formControl]="resultForm.controls['useDelegate']"
            name="useDelegate"
            binary="true"
            inputId="Delegate_3"
          ></p-checkbox>
          <label for="Delegate_3" class="ml-2">{{'Delegate_3' | translate}}</label>
        </div>
        <span class="p-float-label size_cent form-margin">
          <div>{{'From' | translate}}</div>
          @if (add === true) {
            <p-dropdown
              [emptyMessage]="'Empty' | translate"
              appendTo="body"
              formControlName="fromLogin"
              [options]="fromUser"
              placeholder="{{'From' | translate}}"
              [style]="{ width: '100%' }"
              [filter]="true"
            ></p-dropdown>
          }
          @if (add === false) {
            <input
              pInputText
              formControlName="fromLogin"
              name="fromLogin"
              id="fromLogin"
              autocomplete="off"
              class="p-inputtext"
              />
            }
          </span>
          <span class="p-float-label size_cent form-margin">
            <div>{{'To' | translate}}</div>
            <p-dropdown
              [emptyMessage]="'Empty' | translate"
              appendTo="body"
              formControlName="delegatedLogin"
              [options]="toUser"
              placeholder="{{'To' | translate}}"
              [style]="{ width: '100%' }"
              [filter]="true"
            ></p-dropdown>
          </span>
          <div class="p-float-label size_cent form-margin">
            <div>{{'From_D' | translate}}</div>
            <p-calendar
              appendTo="body"
              formControlName="dateBegin"
              [dateFormat]="'dd/mm/yy'"
              [firstDayOfWeek]="firstDayOfWeek"
              showButtonBar="true"
              name="dateBegin"
            ></p-calendar>
          </div>
          <div class="p-float-label size_cent form-margin">
            <div>{{'From_D_T' | translate}}</div>
            <p-calendar
              appendTo="body"
              formControlName="dateEnd"
              [dateFormat]="'dd/mm/yy'"
              [firstDayOfWeek]="firstDayOfWeek"
              showButtonBar="true"
              name="dateEnd"
            ></p-calendar>
          </div>
        </div>
      </div>
    </form>
    <div class="grid col-12 md:col-6">
    <div class="col-offset-6 col-3">
        <button
                (click)="cancel()"
                type="button"
                class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
        >
            {{'Cancel' | translate}}
        </button>
    </div>
    <div class="col-3">
        <button
                (click)="validate()"
                type="button"
                class="p-button p-component p-button-text-only btn-square margin"
        >
            {{'Valid' | translate}}
        </button>
    </div>
    </div>
  </div>


